export default {
  request_sms: "/v1/auth/request_sms_verification",
  verify_code: "/v1/auth/sms_code_authentication",
  google_login: "/v1/auth/google",
  apple_login: "/v1/auth/apple",
  google_link: "/v1/auth/google/link",
  apple_link: "/v1/auth/apple/link",
  provider_2fa_verify: "/v1/auth/provider/2fa/verify",
  two_factor_settings: "/v1/auth/2fa/settings",
  verify_admin: "/v1/admin/user/permissions",
  authenticated_user: "/v1/auth",
  update_user: "/v1/user",
  logout: "/v1/logout",
  platform_stats: "/v1/admin/dashboard/platform/stats",
  store_stats: "/v1/store/stats",
  store_catalog_stats: "/v1/store/catalog/stats",
  charts_data: "/v1/store/chart/data",
  insights_discovery: "/v2/insights/discovery",
  insights_summary: "/v2/insights/summary",
  insights_trends: "/v2/insights/trends",
  insights_product_comparison: "/v2/insights/products/compare",
  insights_catalog: "/v2/insights/catalog",
  insights_explore: "/v2/insights/explore",
  insights_definitions: "/v2/insights/definitions",
  insights_definition: (definitionId) =>
    `/v2/insights/definitions/${definitionId}`,
  insights_definition_execute: (definitionId) =>
    `/v2/insights/definitions/${definitionId}/execute`,
  insights_task: (taskRecordId) =>
    `/v2/insights/tasks/${taskRecordId}`,
  insights_task_file: (taskRecordId, filename) =>
    `/v2/insights/tasks/${taskRecordId}/files/${encodeURIComponent(filename)}`,
  store_dashboard_types: "/v1/store/dashboard/types",
  dashboard_share_link: "/v1/store/dashboard/share",
  shared_dashboard_data: "/v1/store/shared/dashboard/data",
  get_user_stores: "/v1/store/me",
  get_store_shared_data: "/v1/store/shared/dashboard",
  store_promo_codes: "/v1/store/promo_codes/store",
  copy_promo_codes: "/v1/store/copy/promo_codes",
  update_promo_code: "/v1/store/promo_codes",
  get_all_products: "/v2/store/inventory",
  inventory_settings: (storeId) =>
    `/v2/store/${storeId}/inventory/settings`,
  inventory_commitment_deficits: (storeId) =>
    `/v2/store/${storeId}/inventory/commitments/deficits`,
  inventory_commitment_reconcile: (storeId, commitmentLineId) =>
    `/v2/store/${storeId}/inventory/commitments/deficits/${commitmentLineId}/reconcile`,
  store_product: "/v1/store/product",
  get_all_services: "/v2/store/service/store",
  store_service: "/v1/store/service",
  store_expenses: (storeId) => `/v2/store/expense/store/${storeId}`,
  store_expense: "/v1/store/expense",
  store_expense_tag: "/v1/store/expense/tag",
  store_expense_history: (expenseId) => `/v1/store/expense/${expenseId}/history`,
  sale_carts_by_status: (storeId, status) =>
    `/v2/store/sale/cart/status/${storeId}/${status}`,
  ticket_carts: (storeId) => `/v2/store/${storeId}/ticket/carts`,
  ticket_cart: (ticketId) => `/v2/store/ticket/carts/${ticketId}`,
  rra_expense_natures: "/v2/store/expense/natures",
  rra_expense_metadata: (storeId, expenseId) =>
    `/v2/store/${storeId}/expense/${expenseId}/metadata`,
  store_expense_documents: (storeId, expenseId) =>
    `/v2/store/${storeId}/expense/${expenseId}/documents`,
  store_expense_document_file: (storeId, filename) =>
    `/v2/store/${storeId}/expense/documents/${filename}`,
  store_tags: (storeId) => `/v1/store/tag/store/${storeId}`,
  store_tag: "/v1/store/tag",
  copy_catalog_to_stores: "/v2/store/item/copy",
  rra_ebm_settings: "/v1/rra_ebm/store/settings",
  rra_ebm_settings_change_requests:
    "/v2/rra/ebm/store/settings/change/requests",
  store_details_change_requests: "/v2/store/details/change/requests",
  store_v1: "/v1/store",
  store_v2: "/v2/store",
  store_timezones: "/v1/store/timezones",
  store_v1_ebm: "/v1/rra/ebm/store",
  review_rra_ebm_requests: (id) =>
    `/v1/rra/ebm/store/settings/change/requests/${id}/review`,
  review_store_details_change_requests: (id) =>
    `/v1/store/details/change/requests/${id}/review`,
  vsdc_server_setting:
    "/v1/admin/runtime-settings/rra-ebm-client-api-root-url",
  vsdc_server_setting_change_request:
    "/v1/admin/runtime-settings/rra-ebm-client-api-root-url/change-request",
  vsdc_server_setting_apply:
    "/v1/admin/runtime-settings/rra-ebm-client-api-root-url/apply-approved",
  vsdc_server_setting_history:
    "/v1/admin/runtime-settings/rra_ebm_client_api_root_url/history",
  vsdc_server_setting_rollback_request:
    "/v1/admin/runtime-settings/rra_ebm_client_api_root_url/rollback-change-request",
  vsdc_server_setting_rollback_apply:
    "/v1/admin/runtime-settings/rra_ebm_client_api_root_url/rollback-approved",
  runtime_setting_approvals:
    "/v1/approvals/requests?action_key=runtime_settings.update",
  approve_request: (id) => `/v1/approvals/requests/${id}/approve`,
  reject_request: (id) => `/v1/approvals/requests/${id}/reject`,
  // EBM specific endpoints
  store_product_patch: "/v1/store/product",
  store_product_purchase_patch: "/v1/store/product/purchase",
  store_product_get: (id) => `/v1/store/product/${id}`,
  store_product_purchase_get: (id) => `/v1/store/product/purchase/${id}`,
  // Notifications
  get_user_push_notifications: "/v2/notifications/push",
  mark_push_notification_as_read: (id) =>
    `/v2/notifications/push/${id}/mark-as-read`,
  register_push_notification_device_token:
    "/v2/notifications/push/register-token",
  test_push_notification: "/v2/notifications/push/test",
  get_user_notification_preferences: "/v2/notifications/preferences",
  update_user_notification_preferences: "/v2/notifications/preferences",
  get_store_notification_preferences: (storeId) =>
    `/v2/stores/${storeId}/notifications/preferences`,
  update_store_notification_preferences: (storeId) =>
    `/v2/stores/${storeId}/notifications/preferences`,
  // Purchases (V2)
  purchase_suppliers: (storeId) => `/v2/store/${storeId}/purchase/suppliers`,
  purchase_supplier: (storeId, supplierId) =>
    `/v2/store/${storeId}/purchase/suppliers/${supplierId}`,
  bulk_purchase_create: "/v1/store/product/purchase/sheet",
  purchase_batches: (storeId) =>
    `/v1/store/${storeId}/product/purchase/batches`,
  purchase_batch: (storeId, batchId) =>
    `/v1/store/${storeId}/product/purchase/batches/${batchId}`,
  purchase_orders: (storeId) => `/v2/store/${storeId}/purchase/orders`,
  purchase_order: (storeId, orderId) =>
    `/v2/store/${storeId}/purchase/orders/${orderId}`,
  purchase_order_send: (storeId, orderId) =>
    `/v2/store/${storeId}/purchase/orders/${orderId}/send`,
  purchase_order_cancel: (storeId, orderId) =>
    `/v2/store/${storeId}/purchase/orders/${orderId}/cancel`,
  purchase_order_invoice: (storeId, orderId) =>
    `/v2/store/${storeId}/purchase/orders/${orderId}/invoice`,
  purchase_order_recalculate: (storeId, orderId) =>
    `/v2/store/${storeId}/purchase/orders/${orderId}/recalculate`,
  goods_receipts: (storeId) => `/v2/store/${storeId}/purchase/goods-receipts`,
  goods_receipt: (storeId, receiptId) =>
    `/v2/store/${storeId}/purchase/goods-receipts/${receiptId}`,
  goods_receipt_approve: (storeId, receiptId) =>
    `/v2/store/${storeId}/purchase/goods-receipts/${receiptId}/approve`,
  goods_receipt_reject: (storeId, receiptId) =>
    `/v2/store/${storeId}/purchase/goods-receipts/${receiptId}/reject`,
  // Product search (V2)
  store_products_search: (storeId) =>
    `/v2/store/product/store/search/${storeId}`,
  // Purchase order documents
  purchase_order_documents: (storeId, orderId) =>
    `/v2/store/${storeId}/purchase/orders/${orderId}/documents`,
  purchase_order_document_file: (storeId, filename) =>
    `/v2/store/${storeId}/purchase/orders/document/${filename}`,
  goods_receipt_documents: (storeId, receiptId) =>
    `/v2/store/${storeId}/purchase/goods-receipts/${receiptId}/documents`,
  goods_receipt_document_file: (storeId, filename) =>
    `/v2/store/${storeId}/purchase/receipts/document/${filename}`,
  // Store Assets
  store_assets: (storeId) => `/v2/store/${storeId}/assets`,
  store_asset: () => `/v2/store/asset`,
  store_asset_condition: () => `/v2/store/asset/condition`,
  store_asset_categories: (storeId) => `/v2/store/${storeId}/asset-categories`,
  store_asset_category: (storeId, categoryId) =>
    `/v2/store/${storeId}/asset-categories/${categoryId}`,
  admin_jack_store_access: "/v1/admin/jack/store-access",
  admin_jack_store_access_revoke: "/v1/admin/jack/store-access/revoke",
  admin_jack_active_accesses: "/v1/admin/jack/store-access/active",
  admin_jack_logs: "/v1/admin/jack/logs",
  store_roles: "/v1/store/roles",
  store_permissions_catalog: "/v1/store/permissions/catalog",
  group_permissions_catalog: "/v2/groups/permissions/catalog",
  assign_store_user_permissions: "/v1/store/user/permissions/assign",
  delete_store_user_permissions: "/v1/store/user/permissions/user",
  store_users_permissions: (storeId) =>
    `/v1/store/user/permissions/store/${storeId}`,
  admin_jack_user_lookup: "/v1/admin/jack/user/lookup",
  admin_transfer_store_ownership: (storeId) =>
    `/v1/admin/stores/${storeId}/transfer-ownership`,
  generate_store_merchant_code: (storeId) =>
    `/v1/store/${storeId}/merchant-code`,
  store_currency_exchange_rates: (storeId) =>
    `/v1/store/${storeId}/currency-exchange-rates`,
  operational_unit_types: (storeId) =>
    `/v2/store/${storeId}/operational-unit-types`,
  operational_unit_type: (storeId, typeId) =>
    `/v2/store/${storeId}/operational-unit-types/${typeId}`,
  operational_units: (storeId) =>
    `/v2/store/${storeId}/operational-units`,
  operational_unit: (storeId, unitId) =>
    `/v2/store/${storeId}/operational-units/${unitId}`,
  operational_unit_availability: (storeId) =>
    `/v2/store/${storeId}/operational-units/availability`,
  operational_unit_statistics: (storeId) =>
    `/v2/store/${storeId}/operational-units/statistics`,
  ticket_operational_unit: (storeId, ticketId) =>
    `/v2/store/${storeId}/tickets/${ticketId}/operational-unit`,
  ticket_operational_unit_history: (storeId, ticketId) =>
    `/v2/store/${storeId}/tickets/${ticketId}/operational-unit-history`,
  sale_cart_operational_unit: (storeId, saleCartId) =>
    `/v2/store/${storeId}/sale-carts/${saleCartId}/operational-unit`,
  sale_cart_operational_unit_correction: (storeId, saleCartId) =>
    `/v2/store/${storeId}/sale-carts/${saleCartId}/operational-unit-correction`,
  sale_cart_operational_unit_history: (storeId, saleCartId) =>
    `/v2/store/${storeId}/sale-carts/${saleCartId}/operational-unit-history`,
  operational_unit_release: (storeId, unitId) =>
    `/v2/store/${storeId}/operational-units/${unitId}/release`,
  admin_jack_stores: "/v1/admin/jack/stores",
  // Store Transaction endpoints
  store_transactions: (storeId) => `/v2/store-transactions/stores/${storeId}`,
  store_transaction_details: (uuid) => `/v2/store-transactions/${uuid}`,
  store_transaction_retry: (uuid) => `/v2/store-transactions/${uuid}/retry`,
  store_transaction_retriable: (uuid) =>
    `/v2/store-transactions/${uuid}/retriable`,
  store_transactions_retry_all: (storeId) =>
    `/v2/store-transactions/stores/${storeId}/retry-all`,
  store_transactions_stats: (storeId) =>
    `/v2/store-transactions/stores/${storeId}/retry-stats`,
  // Background task endpoints
  background_task_status: (taskId) => `/v1/background/tasks/${taskId}`,
  background_tasks_batch: "/v1/background/tasks/batch",
  // Store reports
  store_reports: (storeId) => `/v2/store/${storeId}/reports`,
  store_report_datasets: (storeId) =>
    `/v2/store/${storeId}/report-datasets`,
  store_report_definitions: (storeId) =>
    `/v2/store/${storeId}/report-definitions`,
  store_published_report_definitions: (storeId) =>
    `/v2/store/${storeId}/report-definitions/published`,
  store_custom_report_subscriptions: (storeId) =>
    `/v2/store/${storeId}/report-subscriptions/custom`,
  store_custom_report_subscription: (storeId, subscriptionUuid) =>
    `/v2/store/${storeId}/report-subscriptions/custom/${encodeURIComponent(subscriptionUuid)}`,
  store_report_definition: (storeId, definitionId) =>
    `/v2/store/${storeId}/report-definitions/${definitionId}`,
  store_report_definition_preview: (storeId, definitionId) =>
    `/v2/store/${storeId}/report-definitions/${definitionId}/preview`,
  store_report_definition_export: (storeId, definitionId, format = "XLSX") =>
    `/v2/store/${storeId}/report-definitions/${definitionId}/export?format=${encodeURIComponent(format)}`,
  store_report_definition_publish: (storeId, definitionId) =>
    `/v2/store/${storeId}/report-definitions/${definitionId}/publish`,
  store_report_definition_draft: (storeId, definitionId) =>
    `/v2/store/${storeId}/report-definitions/${definitionId}/draft`,
  store_report_definition_public_template: (storeId, definitionId) =>
    `/v2/store/${storeId}/report-definitions/${definitionId}/public-template`,
  store_report_templates: (storeId) =>
    `/v2/store/${storeId}/report-templates`,
  clone_store_report_template: (storeId, templateKey) =>
    `/v2/store/${storeId}/report-templates/${encodeURIComponent(templateKey)}/clone`,
  store_public_report_templates: (storeId) =>
    `/v2/store/${storeId}/report-templates/public`,
  store_public_report_template: (storeId, templateUuid) =>
    `/v2/store/${storeId}/report-templates/public/${encodeURIComponent(templateUuid)}`,
  public_report_template: (templateUuid) =>
    `/v2/report-templates/public/${encodeURIComponent(templateUuid)}`,
  clone_public_report_template: (storeId, templateUuid) =>
    `/v2/store/${storeId}/report-templates/public/${encodeURIComponent(templateUuid)}/clone`,
  store_report_download: (storeId, queryParams = {}) => {
    const search = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        search.set(key, value);
      }
    });
    const query = search.toString();
    return `/v2/store/${storeId}/reports/download${query ? `?${query}` : ""}`;
  },
  store_report_file: (storeId, reportId, fileName) =>
    `/v2/store/${storeId}/reports/${reportId}/files/${encodeURIComponent(
      fileName,
    )}`,
  // Admin request logs endpoints
  admin_request_logs: "/v1/admin/request_logs",
  admin_request_log_details: (id) => `/v1/admin/request_logs/${id}`,
  // EBM initialization endpoint
  rra_ebm_initializer: "/v1/rra_ebm/initializer/selectInitInfo",
  // Admin EBM endpoints
  admin_ebm_store_settings: (storeId) =>
    `/v1/admin/ebm/store/${storeId}/settings`,
  // Admin system feature flags
  admin_feature_flags: "/v1/admin/feature-flags",
  admin_feature_flag: (key) =>
    `/v1/admin/feature-flags/${encodeURIComponent(key)}`,
  // QuickBooks Online integration
  qbo_auth_url: (storeId) => `/v1/quickbooks/auth/url/${storeId}`,
  qbo_disconnect: (storeId) => `/v1/quickbooks/auth/disconnect/${storeId}`,
  qbo_settings: (storeId) => `/v1/quickbooks/store/settings/${storeId}`,
  qbo_update_settings: (storeId) => `/v1/quickbooks/store/settings/${storeId}`,
  qbo_sync_status: (storeId) => `/v1/quickbooks/store/${storeId}/sync/status`,
  qbo_sync_details: (storeId) => `/v1/quickbooks/store/${storeId}/sync/details`,
  qbo_trigger_sync: (storeId) => `/v1/quickbooks/store/${storeId}/sync`,
  qbo_payment_account_mappings: (storeId) => `/v1/quickbooks/store/${storeId}/payment-account-mappings`,
  qbo_deposit_accounts: (storeId) => `/v1/quickbooks/store/${storeId}/qbo-deposit-accounts`,
  qbo_payment_methods: (storeId) => `/v1/quickbooks/store/${storeId}/qbo-payment-methods`,
  // Admin deploy
  admin_deploy_staging: "/v1/admin/deploy/staging",
};
